/**
 * /auth/callback route. The API's auth-callback handler does the actual OIDC
 * exchange and 302-redirects before the SPA loads. This page is a safety net
 * for the case where the redirect arrives at the SPA before the cookie is
 * set, or if someone hits the route manually.
 */
import { useDocumentTitle } from '@/lib/useDocumentTitle';

export function SigningIn() {
  useDocumentTitle();
  return (
    <div className="flex min-h-screen items-center justify-center bg-candy-cream text-sm text-candy-ink-muted dark:bg-candy-dark-bg dark:text-candy-dark-ink-muted">
      Signing you in...
    </div>
  );
}
